export default class {
  constructor(list) {
    const date = {};
    date.start = list[0];
    date.end = list[1];
    return date;
  }
}
